import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const deleteQuizQuestion = (questionId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.DELETE_QUIZ_QUESTION(questionId)
  );
};

export default deleteQuizQuestion;
